const doc = [({"da":({"js":({"admin":({"contacts":({"show":({"person":({"surveys_nav":({"teams":"Hold", "team_surveys":"Spørgeskemabesvarelser"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;